import { Spacing, SpacingSizes } from "@components/Spacing";
import { H3, Title1 } from "@components/Typography";
import { useGoalsContext, useProjectedChart } from "@hooks";
import { i18n, Translations } from "@i18n";
import { formatCurrency } from "@utils";
import { useStyles } from "./styles";

export const ProjectedChartHeader = () => {
  const styles = useStyles();

  const { beneficiary } = useGoalsContext();

  const { projectedAmount } = useProjectedChart();

  const firstName = beneficiary?.firstName ?? "";

  return (
    <div>
      <Spacing size={SpacingSizes.XS} />

      <H3 style={styles.title}>
        {i18n.t(Translations.DashboardRouteChartHeaderTitle, {
          name: firstName,
        })}
      </H3>

      <Spacing size={SpacingSizes.M} />

      <Title1 style={styles.text}>{formatCurrency(projectedAmount)}</Title1>
      <Spacing size={SpacingSizes.XXXL} />
    </div>
  );
};
